
























import { Component, Vue, Watch } from 'vue-property-decorator'
import { AloPiscine } from '@/models/alo/AloPiscine'
import { getImageUrl } from '@/utils/images'
import { getDefaultAloActivity } from '@/models/alo/AloActivity'

const searchSensibility = 300

@Component({
  name:"PiscineListItem",
  components: {    
  },
  props:{
    piscine:Object
  }
})
export default class PiscineListItem extends Vue {
  piscine!:AloPiscine

  get getImageUrl(){
    return getImageUrl
  }

  get hasGps(){
    return this.piscine?.address?.gpsLat && this.piscine?.address?.gpsLon
  }

  get imageUrl(){    
    return getImageUrl(this.piscine.image,130,130,"crop")
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get activites(){
    return this.piscine.acyIds.map(id => this.activityDic[id]).filter(it => !!it)
  }
}
